import { userMetaDataKeys } from '@inbox-demo-nx/constants';
import { useAuthContext } from '@inbox-demo-nx/contexts';
import { useMemo } from 'react';
import SendBird from 'sendbird';

export default function useCanCall(channel?: SendBird.GroupChannel | null) {
  const { currentUser } = useAuthContext();

  const canCall = useMemo(() => {
    if (!channel || channel.members.length !== 2 || !currentUser) {
      return false;
    }

    const otherUser = channel.members.find(
      (user) => user.userId !== currentUser.userId
    );

    const canCall =
      !!otherUser && otherUser.metaData[userMetaDataKeys.userType] === 'friend';
    return canCall;
  }, [channel, currentUser]);

  return canCall;
}
